let listeners;

const init = () => {
  listeners?.abort();

  const header = document.querySelector('.header');
  if (!header) return;

  listeners = new AbortController();
  const { signal } = listeners;
  const feature = document.querySelector('.feature');

  let raf = 0;
  let ultimoY = scrollY;

  const update = () => {
    raf = 0;

    if (feature) {
      const rect = feature.getBoundingClientRect();
      header.classList.toggle('is-nav-hidden', rect.top <= 60 && rect.bottom >= 60);
    }

    const y = scrollY;
    if (Math.abs(y - ultimoY) >= 8) {
      header.classList.toggle('is-scrolled-down', y > ultimoY && y > 120);
      ultimoY = y;
    }
  };

  const request = () => {
    if (!raf) raf = requestAnimationFrame(update);
  };

  addEventListener('scroll', request, { passive: true, signal });
  addEventListener('resize', request, { signal });
  update();

  const triggers = header.querySelectorAll('[data-panel-open]');
  let openPanel = null;

  const closePanel = () => {
    if (!openPanel) return;
    const trigger = header.querySelector(`[data-panel-open="${openPanel}"]`);
    const panel = header.querySelector(`[data-panel="${openPanel}"]`);
    const fuocoDentro = panel?.contains(document.activeElement);
    trigger?.setAttribute('aria-expanded', 'false');
    panel?.setAttribute('hidden', '');
    if (fuocoDentro) trigger?.focus();
    openPanel = null;
  };

  const openPanelByName = (name) => {
    if (openPanel === name) return closePanel();

    const eUnCambio = openPanel !== null;
    if (eUnCambio) header.classList.add('is-switching');

    closePanel();
    const panel = header.querySelector(`[data-panel="${name}"]`);
    if (!panel) {
      header.classList.remove('is-switching');
      return;
    }
    panel.removeAttribute('hidden');
    header.querySelector(`[data-panel-open="${name}"]`)?.setAttribute('aria-expanded', 'true');
    openPanel = name;

    if (eUnCambio) {
      requestAnimationFrame(() => requestAnimationFrame(() => header.classList.remove('is-switching')));
    }
  };

  for (const trigger of triggers) {
    trigger.addEventListener('click', () => openPanelByName(trigger.dataset.panelOpen), { signal });
  }

  document.addEventListener(
    'pointerdown',
    (event) => {
      if (openPanel && !event.target.closest('.megamenu, [data-panel-open]')) closePanel();
    },
    { signal }
  );
  document.addEventListener('keydown', (event) => event.key === 'Escape' && closePanel(), { signal });
  addEventListener('scroll', closePanel, { passive: true, signal });

  const drawer = header.querySelector('[data-menu-drawer]');
  const toggle = header.querySelector('[data-menu-toggle]');
  const toggleLabel = toggle?.querySelector('[data-menu-toggle-label]');
  const menuLabel = toggleLabel?.textContent.trim();
  const crumbs = drawer?.querySelector('[data-mmenu-crumbs]');
  const trail = drawer?.querySelector('[data-mmenu-trail]');

  const showView = (path) => {
    const view = drawer?.querySelector(`[data-view="${path}"]`);
    if (!view) return;
    drawer.querySelector('.mmenu__view.is-active')?.classList.remove('is-active');
    view.classList.add('is-active');
    crumbs.hidden = path === '';
    if (path === '') return;
    const parts = path.split('/');
    const parent = parts.length > 1 ? drawer.querySelector(`[data-view="${parts[0]}"]`)?.dataset.title : '';
    const current = view.dataset.title ?? '';
    trail.replaceChildren();
    if (parent) {
      const span = document.createElement('span');
      span.className = 'mmenu__trail-parent';
      span.textContent = `${parent}/`;
      trail.append(span);
    }
    trail.append(document.createTextNode(parent ? current : `${current}/`));
  };

  drawer?.addEventListener(
    'click',
    (event) => {
      const go = event.target.closest('[data-mmenu-go]');
      if (go) return showView(go.dataset.mmenuGo);
      if (event.target.closest('[data-mmenu-back]')) {
        const active = drawer.querySelector('.mmenu__view.is-active')?.dataset.view ?? '';
        return showView(active.split('/').slice(0, -1).join('/'));
      }
      if (event.target.closest('[data-menu-close]') || event.target === drawer) drawer.close();
    },
    { signal }
  );

  toggle?.addEventListener(
    'click',
    () => {
      if (drawer?.open) return drawer.close();
      drawer?.showModal();
      toggle.setAttribute('aria-expanded', 'true');
      if (toggleLabel) toggleLabel.textContent = toggle.dataset.closeLabel ?? toggleLabel.textContent;
    },
    { signal }
  );

  drawer?.addEventListener(
    'close',
    () => {
      toggle?.setAttribute('aria-expanded', 'false');
      if (toggleLabel && menuLabel) toggleLabel.textContent = menuLabel;
      showView('');
    },
    { signal }
  );

  matchMedia('(max-width: 1099px)').addEventListener('change', () => drawer?.close(), { signal });
};

init();

document.addEventListener('shopify:section:load', ({ target }) => {
  if (target.querySelector('.header')) init();
});
